import { h } from 'preact';
import { isWebPSupported } from 'utils/isWebPSupported';

const mimeTypesMap = { jpg: 'jpeg', png: 'png' };
const getMimeType = (ext) => `image/${mimeTypesMap[ext] || ext}`;

export function getAssetUrl(src, fallbackFormat = 'jpg') {
	return isWebPSupported() ? src : src?.replace(/\.webp$/, `.${fallbackFormat}`);
}

export function Picture({ src, fallbackFormat, ...props }) {
	if (!src?.endsWith?.('.webp')) {
		return <img {...props} src={src} key={src} />;
	}
	fallbackFormat = fallbackFormat || 'jpg';
	let fallback = src.slice(0, -4) + fallbackFormat;
	return (
		<picture>
			<source srcset={src} type="image/webp" />
			<source srcset={fallback} type={getMimeType(fallbackFormat)} />
			<img {...props} src={fallback} key={fallback} />
		</picture>
	);
}

export function css(asset, fallbackFormat) {
	return asset ? `url("${encodeURI(getAssetUrl(asset, fallbackFormat))}")` : '';
}